// Presentation only: canonical booking, offer and deposit states come from the API.
// Never infer payment, reserve a slot or change a workflow from this helper.
export function clientBookingProgress(booking = {}, proposal = booking.reschedule_proposal, appointment) {
  const deposit = booking.deposit_requirement?.status || appointment?.deposit_requirement?.status;
  if (!["pending", "approved"].includes(booking.status) ||
      ["expired", "paid_needs_reschedule"].includes(deposit) ||
      (appointment && !["scheduled", "confirmed"].includes(appointment.status))) return null;
  const offer = booking.commercial_offer;
  const hasProposal = Boolean(offer || proposal);
  const needsDeposit = Number(offer?.deposit_amount) > 0 || ["pending", "paid"].includes(deposit);
  const steps = ["Richiesta", hasProposal ? "Proposta" : "Studio", ...(needsDeposit ? ["Acconto"] : []), "Conferma"];
  // A booking approval/payment alone is never proof of a confirmed appointment.
  const complete = appointment?.status === "confirmed" && deposit !== "pending";
  const current = deposit === "pending" ? steps.indexOf("Acconto") : booking.status === "approved" ? steps.length - 1 : 1;
  return { steps, current, complete, confirmation: complete ? "Appuntamento confermato" : booking.status === "approved" && deposit !== "pending" ? (appointment?.status === "scheduled" ? "Appuntamento programmato" : "Conferma da verificare negli appuntamenti") : "" };
}

export function clientBookingGuidance(booking = {}, proposal = booking.reschedule_proposal) {
  const deposit = booking.deposit_requirement?.status;
  if (deposit === "paid_needs_reschedule") return {
    label: "Nuova data da concordare",
    next: "L’acconto è stato ricevuto, ma la data non è confermata. Contatta lo Studio per concordare un nuovo appuntamento.",
  };
  const closed = {
    rejected: ["Richiesta rifiutata", "Questa richiesta è chiusa. Puoi contattare lo Studio o inviare una nuova richiesta."],
    cancelled: ["Richiesta annullata", "Questa richiesta non è più attiva."],
    canceled: ["Richiesta annullata", "Questa richiesta non è più attiva."],
    expired: ["Richiesta scaduta", "Apri i dettagli per verificare il motivo e contatta lo Studio per riprendere la prenotazione."],
    transferred: ["Trasferita ad altra sede", "Continua dalla nuova richiesta nella sede scelta."],
  }[booking.status];
  if (closed) return { label: closed[0], next: closed[1] };
  if (deposit === "pending") return {
    label: "In attesa di acconto",
    next: "Data e prezzo sono stati accettati. Per confermare la prenotazione, completa l’acconto entro la scadenza indicata nei dettagli.",
  };
  if (deposit === "expired") return {
    label: "Acconto scaduto",
    next: "La prenotazione non è confermata. Contatta lo Studio prima di procedere.",
  };
  if (booking.status === "pending" && booking.commercial_offer?.status === "awaiting_client") return {
    label: "Data e prezzo da accettare",
    next: "Ora tocca a te: apri la proposta, controlla data e prezzo e scegli se accettare o rifiutare.",
  };
  if (booking.status === "pending" && proposal?.status === "awaiting_client") return {
    label: "Nuovo orario da valutare",
    next: "Ora tocca a te: apri i dettagli per accettare l’orario proposto o proporne un altro.",
  };
  if (booking.status === "pending" && proposal?.status === "countered") return {
    label: "In attesa dello Studio",
    next: "Il tuo nuovo orario è stato inviato. Attendi la risposta dello Studio; non serve inviare di nuovo la richiesta.",
  };
  if (booking.status === "approved") return {
    label: "Richiesta accettata",
    next: "Trovi data, stato aggiornato e attività da completare nella sezione Appuntamenti.",
  };
  if (booking.status === "pending") return {
    label: "In attesa dello Studio",
    next: booking.assignment_status === "unassigned"
      ? "Lo Studio deve assegnare il professionista e valutare la richiesta. La data indicata è ancora una preferenza."
      : "Lo Studio deve valutare la richiesta. La data non è ancora confermata; non serve inviare di nuovo la richiesta.",
  };
  return { label: "Stato da verificare", next: "Apri i dettagli o contatta lo Studio per conoscere il prossimo passo." };
}
